import { ApiKeysList } from './api-keys-list'
import { usePageTitle } from '../../../hooks/title'
import { useTranslation } from 'react-i18next'

export const ApiKeysPage = () => {
  const { t } = useTranslation(['api_keys'])
  usePageTitle(t('api_keys:page_title'))

  return <ApiKeysList />
}
